import { type CallIntegrationRequest, NodeInstance } from '@glueapp/graph-types';
import { NodeStandardLayout } from '@/GraphEditor/drawingLayer/nodeComposition/NodeStandardLayout';
import { useCurrentNode } from '@/GraphEditor/drawingLayer/contexts/CurrentNodeContext';
import { getInterfaceComponent } from '@/components/nodeInterfaces/ComponentRegistry';
import { useNodeShape } from '@/GraphEditor/drawingLayer/contexts/NodeShapeContext';
import { useNodeState } from '@/GraphEditor/drawingLayer/contexts/NodeStateContext';
import { useCallIntegration } from '@/GraphEditor/drawingLayer/contexts/CallIntegrationContext';

interface Props {
    nodeInstance: NodeInstance;
}

export const StandardNodeWithComponent: React.FC<Props> = ({ nodeInstance }) => {
    const node = useCurrentNode();
    const setNodeShape = useNodeShape();
    const setNodeState = useNodeState();
    const callIntegration = useCallIntegration();
    const renderNodeInterfaceComponent = () => {
        // First try the new interfaceComponentId system
        let NodeInterfaceComponent: React.ElementType<any> | null = null;
        if (node.interfaceComponentId) {
            NodeInterfaceComponent = getInterfaceComponent(node.interfaceComponentId) as React.ElementType<any> | null;
        }

        if (!NodeInterfaceComponent) {
            return null;
        }

        if (node.integration) {
            return (
                <NodeInterfaceComponent
                    nodeState={nodeInstance.state || {}}
                    setNodeState={(key: string, value: any) => {
                        setNodeState({ ...nodeInstance.state, [key]: value });
                    }}
                    integration={{
                        callIntegration: (request: CallIntegrationRequest) => callIntegration(request),
                    }}
                    nodeShape={{
                        nodeInPorts: node.inPorts,
                        nodeOutPorts: node.outPorts,
                        nodeInstanceInPorts: nodeInstance.inPorts,
                        nodeInstanceOutPorts: nodeInstance.outPorts,
                    }}
                    renderSideBar={() => {}}
                    updateShape={setNodeShape}
                />
            );
        } else {
            return (
                <NodeInterfaceComponent
                    nodeState={nodeInstance.state || {}}
                    setNodeState={(key: string, value: any) => {
                        setNodeState({ ...nodeInstance.state, [key]: value });
                    }}
                    integration={undefined}
                    nodeShape={{
                        nodeInPorts: node.inPorts,
                        nodeOutPorts: node.outPorts,
                        nodeInstanceInPorts: nodeInstance.inPorts,
                        nodeInstanceOutPorts: nodeInstance.outPorts,
                    }}
                    renderSideBar={() => {}}
                    updateShape={setNodeShape}
                />
            );
        }
    };
    return <NodeStandardLayout nodeInstance={nodeInstance}>{renderNodeInterfaceComponent()}</NodeStandardLayout>;
};
